module.exports = __webpack_public_path__ + "media/icons/mail-aeacf83b.svg";